import { AxiosResponse } from 'axios'
import get from 'lodash/get'
import { api } from 'API'
import { handleError } from 'API/error'
import {
  ICRSCreditScoreResponse,
  ICRSCriminalTenantData,
  ICRSEvictionTenantData,
  ICRSTenantData
} from 'interfaces/application'

const BASE_PATH: string = '/customer/house-applications'

export async function getFICOCreditScore(tenantData: ICRSTenantData): Promise<ICRSCreditScoreResponse> {
  try {
    const url: string = `${BASE_PATH}/crs-credit-score`
    const response: AxiosResponse = await api.post(url, tenantData)

    return response.data
  } catch (error) {
    const errorMessage: string = get(error, 'response.data.error.message', '') || JSON.stringify(error)
    handleError(error as Error, 'API/houseApplication', 'getFICOCreditScore')
    throw new Error(errorMessage)
  }
}

export async function authenticateCRS(): Promise<void> {
  try {
    const url: string = `${BASE_PATH}/crs-auth`
    await api.post(url)
  } catch (error) {
    const errorMessage: string = get(error, 'response.data.error.message', '') || JSON.stringify(error)
    handleError(error as Error, 'API/houseApplication', 'authenticateCRS')
    throw new Error(errorMessage)
  }
}

export async function uploadCRSReport(pdfReportId: string, phoneNumber: string, buildiumUnitId: number): Promise<void> {
  try {
    const url: string = `${BASE_PATH}/crs-upload-report`
    await api.post(url, {
      pdfReportId,
      phoneNumber,
      buildiumUnitId
    })
  } catch (error) {
    const errorMessage: string = get(error, 'response.data.error.message', '') || JSON.stringify(error)
    handleError(error as Error, 'API/houseApplication', 'uploadCRSReport')
    throw new Error(errorMessage)
  }
}

export async function uploadCriminalReport(
  phoneNumber: string,
  buildiumUnitId: number,
  tenantData: ICRSCriminalTenantData
): Promise<void> {
  try {
    const url: string = `${BASE_PATH}/upload-crs-criminal-report`
    await api.post(url, {
      tenantData,
      phoneNumber,
      buildiumUnitId
    })
  } catch (error) {
    const errorMessage: string = error?.response?.data?.error?.message || JSON.stringify(error)
    handleError(error as Error, 'API/houseApplication', 'uploadCriminalReport')
    throw new Error(errorMessage)
  }
}

export async function uploadEvictionReport(
  phoneNumber: string,
  buildiumUnitId: number,
  tenantData: ICRSEvictionTenantData
): Promise<void> {
  try {
    const url: string = `${BASE_PATH}/upload-crs-eviction-report`
    await api.post(url, {
      tenantData,
      phoneNumber,
      buildiumUnitId
    })
  } catch (error) {
    const errorMessage: string = error?.response?.data?.error?.message || JSON.stringify(error)
    handleError(error as Error, 'API/houseApplication', 'uploadEvictionReport')
    throw new Error(errorMessage)
  }
}
